._title_1p83m_1 {
  display: flex;
  align-items: center; }

._memberSections_1p83m_5 {
  margin: 0px 20px 0px 20px;
  border-radius: 6px;
  border: 1px solid #dfe5eb; }
